import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "p-login-heading-3" }, "メールアドレス認証のお願い", -1)
const _hoisted_2 = { class: "p-login-text-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "--is-align-left" }, [
  /*#__PURE__*/_createTextVNode("メールアドレスの未認証がございます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("変更いただいたメールアドレスにご本人様確認のメールを送信しております。")
], -1)
const _hoisted_4 = { class: "--is-align-left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "【マイナビ転職エージェント】メールアドレス1認証のお知らせ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "【マイナビ転職エージェント】メールアドレス2認証のお知らせ", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "--is-align-left" }, "このメールに認証のURLがありますので、押下いただき、ご本人様確認を完了してください。", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "--is-align-left" }, [
  /*#__PURE__*/_createTextVNode("もしメールが届かない場合は、下記の再設定ボタンから再度メールアドレスを登録するか、FAQページで対応方法をご確認ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://mynavi-agent.jp/service/faq/mynavi/201.html#section2602",
    target: "_blank"
  }, "マイページに関するFAQ")
], -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "メールを再送する", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "再設定する", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "p-recommend-form__text-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "メールアドレス認証のお願い", -1)
const _hoisted_23 = [
  _hoisted_22
]

import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import MailSecurityPopupView from '../mailSecurity/MailSecurityPopupView.vue';
import { postMailSecurityResend } from '@/api/accountEndpoint';
import { MailSecurityResendDetail, MailSecurityResendResponse } from '@/types/emailSerurity';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityWaitAuthenPopupView',
  props: {
  hasEmail1AuthKey: {
    type: Boolean,
    default: false
  },
  email1AuthFlg: {
    type: Boolean,
    default: false
  },
  hasEmail2AuthKey: {
    type: Boolean,
    default: false
  },
  email2AuthFlg: {
    type: Boolean,
    default: false
  },
  email2: {
    type: String,
    default: ''
  },
  isShowVerifyButton: {
    type: Boolean,
    default: true
  },
  isCloseable: {
    type: Boolean,
    default: true
  },
  showPopupByDefault: {
    type: Boolean,
    default: false
  }
},
  emits: ['close', 'authenticated'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter();
const isLoading = ref(false);
const isShowAlert = ref(false);
const isShowMailSecurityWaitAuthen1Popup = ref(false);
const messageDisplay = ref('');
const isDisabledSubmit = ref(false);
const isAlreadyAuthenticated = ref(false);



watch(() => props.showPopupByDefault, (val) => {
  isShowMailSecurityWaitAuthen1Popup.value = val;
}, { immediate: true });



const resendVerifyMailSecurity = async () => {
  if(isDisabledSubmit.value)
  {
    return;
  }
  else
  {
    isDisabledSubmit.value = true;
  }

  isLoading.value = true;
  isShowAlert.value = false;

  try {
    const res = await postMailSecurityResend() as MailSecurityResendResponse;
    const resDetail = res?.detail as MailSecurityResendDetail;
    if (resDetail) {
      isShowAlert.value = true;
      if (resDetail.isAlreadyAuthenticated) {
        isAlreadyAuthenticated.value = true;
        messageDisplay.value = 'このメールアドレスは認証済です。';
      } else if (resDetail.isSendMailError) {
        messageDisplay.value = 'メールアドレスの認証依頼の送信に失敗しました。';
      } else {
        // When email1 is unverified, keep the blocking popup visible even after resend success.
        isShowMailSecurityWaitAuthen1Popup.value = !props.email1AuthFlg;
        messageDisplay.value = 'メールを再送しました';
      }
    }
  } 
  catch (_) {
    // eslint-disable-next-line no-empty
  }
  finally {
    isLoading.value = false;
  }

  isDisabledSubmit.value = false;
};

const closeAlert = () => {
  isShowAlert.value = false;
  if (isAlreadyAuthenticated.value) {
    isShowMailSecurityWaitAuthen1Popup.value = false;
    emit('authenticated');
  }
};

const closeMailSecurityPopup = () => {
  isShowMailSecurityWaitAuthen1Popup.value = !isShowMailSecurityWaitAuthen1Popup.value;
  emit('close');
};

const goToMailSecurityFormScreen = () => {
  isShowMailSecurityWaitAuthen1Popup.value = false;
  emit('close');
  router.push({
    name: 'mss03',
    query: {
      from: 'mail-security-wait-authen'
    }
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowMailSecurityWaitAuthen1Popup.value || !__props.isShowVerifyButton)
      ? (_openBlock(), _createBlock(MailSecurityPopupView, {
          key: 0,
          isShowCloseBtnPopup: props.isCloseable,
          onClose: closeMailSecurityPopup
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, [
                _createTextVNode("メール件名： "),
                (props.hasEmail1AuthKey && !props.email1AuthFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_8))
                  : _createCommentVNode("", true),
                (props.email2 && props.hasEmail2AuthKey && !props.email2AuthFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_13,
              _hoisted_14
            ]),
            _createElementVNode("button", {
              class: "p-recommend-button --type-2 --width-set-1 --has-icon t-decoration-none",
              type: "button",
              onClick: _withModifiers(resendVerifyMailSecurity, ["prevent"])
            }, _hoisted_17, 8, _hoisted_15),
            _createElementVNode("button", {
              class: "p-recommend-button --type-2 --width-set-1 --has-icon t-decoration-none u-mt-8",
              type: "button",
              onClick: _withModifiers(goToMailSecurityFormScreen, ["prevent"])
            }, _hoisted_20, 8, _hoisted_18)
          ]),
          _: 1
        }, 8, ["isShowCloseBtnPopup"]))
      : _createCommentVNode("", true),
    (isShowAlert.value)
      ? (_openBlock(), _createBlock(MailSecurityPopupView, {
          key: 1,
          isShowCloseBtnPopup: true,
          isShowSecondClosePopup: true,
          onClose: closeAlert
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_21, _toDisplayString(messageDisplay.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isShowVerifyButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "p-mail-security-modal-button js-modal-open-button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isShowMailSecurityWaitAuthen1Popup.value=!isShowMailSecurityWaitAuthen1Popup.value), ["prevent"]))
        }, _hoisted_23))
      : _createCommentVNode("", true)
  ], 64))
}
}

})